import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Button from "../../components/Button/Button";
import FormActions from "../../components/FormActions/FormActions";
import VideoUpload from "../../components/VideoUpload/VideoUpload";
import { withFirebase } from "../../components/Firebase/Firebase";
import { withPrismic } from "../../components/Prismic/Prismic";
import RichText from "../../components/RichText/RichText";

import _ from 'lodash';

class Stage6 extends Component {



	componentDidMount() {

	}

	primaryEmail() {
		let primaryContact = null;
		_.each(this.props.entries, (entry) => {
			_.each(entry.members, (member) => {
				if(member.primaryContact === "on") primaryContact = member
			});
		});
		if(!primaryContact) return null;
		return primaryContact.emailAddress;
	}

	continue = async () => {
		await this.props.methods.updateEntryStage(this.props.id, 7);
	};
	
	previous = async () => {
		await this.props.methods.updateEntryStage(this.props.id, 5);
	};
	
	render() {

		if(!this.props.terms) return null;

		return (
			<div>
			

			<div className="step-header">
				Step 5 of 5
			</div>

			<RichText content={this.props.terms.stage_6} />
			<VideoUpload />
			<FormActions
			left={
				<div>
				<Button onClick={this.previous}>Back</Button>
				</div>
			}
			right={
				<div>
				<Button onClick={this.continue}>I've done this</Button>
				</div>
			}
			/>
			</div>
		);
	}
}

export default withRouter(withPrismic(withFirebase(Stage6)));



// WEBPACK FOOTER //
// ./src/pages/CompetitionEnter/Stage6.js